// From: https://github.com/peterpeterparker/web-social-share/blob/main/src/utils/copy.ts

export const copyUrl = async attrs => {
  try {
    await navigator.clipboard.writeText(attrs?.socialShareUrl || window.location.href);
  } catch (err) {
    console.error('It seems that copy is not supported by this browser');
  }
};
